import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import UserProfile from './Components/UserProfileRoute/UserProfile';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function UserProfileRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileRoutePage">
                    <div className="UserProfileRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="UserProfileRouteBlock">
                        <UserProfile/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default UserProfileRoute;